module.exports = __webpack_public_path__ + "0ffecf2e6f8dfd3b42262b61a1bf4ecc.png";